export default "__VITE_ASSET__CJxMTcgv__"